import { styled } from '@linaria/react';

import { ButtonIconGhost } from '~shared/ui/atoms/Buttons/ButtonGhost/Icon';

export const StyledErrorModalWrapper = styled.div`
	position: relative;
	display: flex;
	width: 100%;
	max-width: 42rem;
	flex-direction: column;
	align-items: center;
	align-self: center;
	justify-content: center;
	padding: 4rem 2rem;
	border-radius: var(--radius-l);
	margin-right: auto;
	margin-left: auto;
	background: var(--color-grey-10-solid);
	gap: var(--gap-x8);
`;

export const CloseButton = styled(ButtonIconGhost)`
	position: absolute;
	top: 1rem;
	right: 1rem;
`;
